import fly, { FlyRequestConfig } from 'flyio';
import { set, get } from 'lodash';
import { UrlType } from '../constants';
var billHostMap = {
  dev: 'https://fp-adminapi-sg.myshoplinedev.com/api/bill/platform',
  test: 'https://fp-adminapi-sg.myshoplinestg.com/api/bill/platform',
  prev: 'https://fp-adminapi-sg-preview.myshopline.com/api/bill/platform',
  prod: 'https://fp-adminapi-sg.myshopline.com/api/bill/platform'
};
var subHostMap = {
  dev: 'https://fp-adminapi-sg.myshoplinedev.com/api/sub/platform',
  test: 'https://fp-adminapi-sg.myshoplinestg.com/api/sub/platform',
  prev: 'https://fp-adminapi-sg-preview.myshopline.com/api/sub/platform',
  prod: 'https://fp-adminapi-sg.myshopline.com/api/sub/platform'
};
export function setBaseURL(newBaseUrl) {
  if (newBaseUrl) {
    set(fly.config, 'extra.baseURL', newBaseUrl);
  }
}

//添加请求拦截器
fly.interceptors.request.use(function (request) {
  var _request$headers, _request$headers2;
  var baseURL = get(fly.config, 'extra.baseURL');
  var accessToken = get(fly.config, 'extra.accessToken');
  var urlType = ((_request$headers = request.headers) === null || _request$headers === void 0 ? void 0 : _request$headers.urlType) || UrlType.SUB;
  if (baseURL) {
    var suffix = '';
    if (urlType === UrlType.SUB) {
      suffix = '/sub/platform/sl';
    } else {
      suffix = '/bill/platform/sl';
    }
    request.baseURL = "".concat(baseURL.replace(/\/$/, '')).concat(suffix);
  } else {
    if (urlType === UrlType.SUB) {
      request.baseURL = subHostMap[window.SETTLEMENT_SDK_ENV || 'dev'];
    } else {
      request.baseURL = billHostMap[window.SETTLEMENT_SDK_ENV || 'dev'];
    }
  }
  if (request.url.startsWith('https://')) {
    request.baseURL = '';
  }
  if ((_request$headers2 = request.headers) !== null && _request$headers2 !== void 0 && _request$headers2.urlType) {
    delete request.headers.urlType;
  }

  // 默认主站和非主站都 delete request.body.merchantNo;
  delete request.body.merchantNo;

  // bizType有值，则代表主站，基参需要保留；bizType没值，则代表非主站，基参不需要再传
  if (!!accessToken) {
    if (!request.body.bizType) {
      delete request.body.appId;
      delete request.body.bizType;
      delete request.body.subBizType;
    }
  }

  //终止请求
  //var err=new Error("xxx")
  //err.request=request
  //return Promise.reject(new Error(""))

  //可以显式返回request, 也可以不返回，没有返回值时拦截器中默认返回request
  return request;
});

//添加响应拦截器，响应拦截器会在then/catch处理之前执行
fly.interceptors.response.use(function (response) {
  var _response$data;
  if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code) !== 'SUCCESS') {
    return Promise.reject(response.data);
  }
  //只将请求结果的data字段返回
  return response.data;
}, function (err) {
  //发生网络错误后会走到这里
  //return Promise.resolve("ssss")
});
export { FlyRequestConfig };
export default fly;